module.exports = __webpack_public_path__ + "img/2015-05_bloomberg.3c76d448.png";